export default __webpack_public_path__ + "static/media/exit.3ba89ae4.svg";